/**
 * TemplateDetailsPanel — thin shell wiring the shared `ListDetailsPanel`
 * substrate with template-specific bits:
 *   - template metadata layout (tags, no work/planning fields)
 *   - template row actions (currently empty post-A1)
 *   - field-feedback provider wraps the body so questions can show inherited
 *     feedback annotations from this template's proto chain
 *
 * Templates have no status badge, no progress indicator (no answers exist),
 * and no PDF download.
 */
import { ListDetailsPanel } from '@/features/lists/ListDetailsPanel';
import { templateDetailLayout } from '@/features/lists/lists.schemas';
import { FieldFeedbackProvider } from '@/features/feedback/components/FieldFeedbackContext';
import type { RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import type { List } from '@certhon/models';
import type { ReactNode } from 'react';
import { getTemplateActions } from './templates.actions';

const wrapBody = (body: ReactNode, list: List) => (
  <FieldFeedbackProvider protoListId={list.id}>{body}</FieldFeedbackProvider>
);

export function TemplateDetailsPanel(props: RoutedPanelProps) {
  return (
    <ListDetailsPanel
      {...props}
      layout={templateDetailLayout}
      getActions={getTemplateActions}
      wrapBody={wrapBody}
    />
  );
}
